import { License, SupportPurchase } from '../../api/api-generated';
import { useFindAllSupportPurchasesQuery } from '../../api/api-hooks';

export const useGetMostRecentSupportPurchase = () => {
  const { data: allSupportPurchases } = useFindAllSupportPurchasesQuery({});
  if (!allSupportPurchases) return () => undefined;
  return (item: License): SupportPurchase | undefined => {
    const relatedSupportPurchases = allSupportPurchases.filter((record) => {
      const hardwareIdsAssociatedWithRecord = record.hardware.map(
        (hardware) => hardware.id
      );
      return (
        record.companyId === item.companyId &&
        record.softwareId === item.softwareId &&
        hardwareIdsAssociatedWithRecord.includes(item.hardwareId)
      );
    });
    if (relatedSupportPurchases.length === 0) return undefined;
    const mostRecentRelatedSupportPurchase = relatedSupportPurchases.reduce(
      (acc, cur) => (acc.dateCreated > cur.dateCreated ? acc : cur),
      relatedSupportPurchases[0]
    );
    return mostRecentRelatedSupportPurchase;
  };
};
